export default class SearchPayload {
  constructor(build) {
    this.search_name = build.search_name
    this.search_mail = build.search_mail
    this.search_agent = build.search_agent
    this.search_admin_name = build.search_admin_name
    this.admin_id = build.admin_id
    this.search_devicename = build.search_devicename
    this.search_mac = build.search_mac
    this.search_username = build.search_username
    this.email = build.email
    this.page_no = build.page_no
    this.lines = build.lines
    this.order_by = build.order_by
    this.search_email = build.search_email
    this.agent_id = build.agent_id
    this.status = build.status
  }

  static get Builder() {
    class Builder {
      constructor(lines = 20, pageNo = 1, orderBy = '') {
        this.lines = lines
        this.page_no = pageNo
        this.order_by = orderBy
      }

      withSearchUsername(searchUsername = '') {
        this.search_username = searchUsername
        return this
      }

      withEmail(email = '') {
        this.email = email
        return this
      }

      withSearchAgent(searchAgent = '') {
        this.search_agent = searchAgent
        return this
      }

      withSearchAdminName(searchAdminName = '') {
        this.search_admin_name = searchAdminName
        return this
      }

      withAdminId(adminId = '') {
        this.admin_id = adminId
        return this
      }

      withSearchName(searchName = '') {
        this.search_name = searchName
        return this
      }

      withSearchMail(searchMail = '') {
        this.search_mail = searchMail
        return this
      }

      withSearchEmail(searchEmail = '') {
        this.search_email = searchEmail
        return this
      }

      withSearchMac(searchMac = '') {
        this.search_mac = searchMac
        return this
      }

      withSearchDevicename(searchDevicename = '') {
        this.search_devicename = searchDevicename
        return this
      }

      withAgentId(agentId = '') {
        this.agent_id = agentId
        return this
      }

      withStatus(status = '') {
        this.status = status
        return this
      }

      build() {
        return new SearchPayload(this)
      }
    }
    return Builder
  }
}
